import React, { FC } from 'react';

import dynamic from 'next/dynamic';

import STATIC_ROUTES from '@data/staticRoutes.json';
import { SFHeaderFooterCategoryFooterViewModel } from '@api/index';
import { Container } from '@shared';

import BasketLink from '../BasketLink';
import {
  DesktopHeaderWrapper,
  IconRectangle,
  LeftColumnWrapper,
  MenuContent,
  MenuListWrapper,
  Rectangle,
  RightColumnWrapper,
} from './DesktopHeaderStyle';
import HeaderMile from '../HeaderMile';
import HeaderReservations from '../HeaderReservations';
import UserMenu from '../../topHeader/userMenu';
import BrandLink from '../BrandLink';
import ButtonLink from '../buttonLinks/ButtonLink';

const MenuListDynamic = dynamic(() => import('../MenuList/MenuList'));

interface IDesktopHeader {
  data: SFHeaderFooterCategoryFooterViewModel['header'];
}

const DesktopHeader: FC<IDesktopHeader> = ({ data }) => {
  return (
    <Container noPadding>
      <DesktopHeaderWrapper>
        <LeftColumnWrapper>
          <BrandLink />

          <MenuListWrapper>
            <IconRectangle />
            <MenuListDynamic data={data} />
          </MenuListWrapper>
        </LeftColumnWrapper>
        <RightColumnWrapper>
          <MenuContent>
            <HeaderMile />

            <HeaderReservations />
            <Rectangle />
            <UserMenu />
            <Rectangle />
            <ButtonLink
              label='HEMEN BAŞVUR'
              href={STATIC_ROUTES.sfCardApplication}
              icon='SFCreditCard'
            />

            <Rectangle />
            <BasketLink />
          </MenuContent>
        </RightColumnWrapper>
      </DesktopHeaderWrapper>
    </Container>
  );
};

export default DesktopHeader;
